import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { api, ApiError } from '@/lib/axios'

type AuthenticateUserRequest = {
  applicationAccountUsersId: string
  currentPassword: string
  applicationPassword: string
}

async function authenticateUserRequest(data: AuthenticateUserRequest) {
  const { data: response } = await api.backend.post(
    '/application-account-users-auth/authenticate-user',
    data,
  )
  return response
}

export function useAuthenticateUser() {
  const { mutateAsync, isPending } = useMutation<
    unknown,
    AxiosError<ApiError>,
    AuthenticateUserRequest
  >({
    mutationKey: ['/application-account-users-auth/authenticate-user'],
    mutationFn: authenticateUserRequest,
  })

  const handleAuthenticateUser = async (data: AuthenticateUserRequest) => {
    return mutateAsync(data)
  }

  return { handleAuthenticateUser, isAuthenticating: isPending }
}
